import { useState } from 'react'
import { Box, TabSelector } from '@/CommonComponents'
import type { IFinding, IFindingStatus } from '@/types/appsec/finding'
import type { ISeverity } from '@/types/severity'
import { getOccurrences } from './utils'
import { useTexts } from '@/contexts/LanguageContext'

interface IStatusFilterProps<T extends IFinding> {
  filterCriteria: {
    status: IFindingStatus | null
    severity: ISeverity | null
    repository?: string | null
  }
  findings: T[]
  onChange: (status: IFindingStatus | null) => void
}
export default function StatusFilter<T extends IFinding>({
  filterCriteria,
  findings,
  onChange,
}: IStatusFilterProps<T>) {
  const { EASM_VULNERABILITIES } = useTexts()
  const { STATUS } = EASM_VULNERABILITIES
  const [selectedStatus, setSelectedStatus] = useState<IFindingStatus>(filterCriteria.status || 'open')
  const tabs = [
    {
      id: 'open' as const,
      label: `${STATUS.open} (${getOccurrences({
        findings,
        severity: filterCriteria.severity,
        status: 'open',
        repository: filterCriteria.repository || null,
      })})`,
    },
    {
      id: 'closed' as const,
      label: `${STATUS.closed} (${getOccurrences({
        findings,
        severity: filterCriteria.severity,
        status: 'closed',
        repository: filterCriteria.repository || null,
      })})`,
    },
  ]

  const handleStatusChange = (status: IFindingStatus) => {
    setSelectedStatus(status)
    onChange(status)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <TabSelector tabs={tabs} selectedTab={selectedStatus} setSelectedTab={handleStatusChange} />
    </Box>
  )
}
